import { BanModalProps } from './interface'

export function withBanModal(Component: React.FC<BanModalProps>) {
  function WithBanModal(props: BanModalProps) {
    return <Component {...props} />
  }

  return WithBanModal
}
